// import { PLATFORM_ID, REQUEST } from '@angular/core'
// import { isPlatformBrowser } from '@angular/common'
// import { inject } from '@angular/core'

// export function isHrmsHost(): boolean {
//   const platformId = inject(PLATFORM_ID)

//   let host = ''
//   let port = ''

//   if (isPlatformBrowser(platformId)) {
//     host = window.location.hostname
//     port = window.location.port
//   } else {
//     // Server-side: request object se host lo
//     const request = inject(REQUEST, { optional: true }) as Request | null
//     if (request) {
//       const url = new URL(request.url)
//       host = url.hostname
//       port = url.port
//     }
//   }

//   return (
//     host === 'localhost' ||
//     host === 'app.avrhrms.com' ||
//     host.endsWith('-app.avrhrms.com') ||
//     port === '4300' ||
//     port === '4206' ||
//     port === '4208' ||
//     port === '4210'
//   )
// }

import { PLATFORM_ID, inject, Optional } from '@angular/core'
import { isPlatformBrowser } from '@angular/common'
import { REQUEST_HOST } from '../host.token'

// export function isHrmsHost(): boolean {
//   const platformId = inject(PLATFORM_ID)
//   let hostWithPort = ''

//   if (isPlatformBrowser(platformId)) {
//     hostWithPort =
//       window.location.hostname + (window.location.port ? ':' + window.location.port : '')
//   } else {
//     const requestHost = inject(REQUEST_HOST, { optional: true })
//     hostWithPort = requestHost || ''
//   }

//   const [host, port] = hostWithPort.split(':')

//   return (
//     // host === 'localhost' ||
//     host === 'app.avrhrms.com' ||
//     (host?.endsWith('-app.avrhrms.com') ?? false) ||
//     port === '4300' ||
//     port === '4206' ||
//     port === '4208' ||
//     port === '4210'
//   )
// }

export function isHrmsHost(): boolean {
  const platformId = inject(PLATFORM_ID)

  let hostWithPort = ''

  if (isPlatformBrowser(platformId)) {
    hostWithPort =
      window.location.hostname + (window.location.port ? ':' + window.location.port : '')

    // console.log('Browser host:', hostWithPort)
  } else {
    const requestHost = inject(REQUEST_HOST, { optional: true })
    hostWithPort = requestHost || ''
    // console.log('Server host:', hostWithPort)
  }

  const [host, port] = hostWithPort.split(':')

  const result =
    host === 'app.avrhrms.com' ||
    (host?.endsWith('-app.avrhrms.com') ?? false) ||
    port === '4300' ||
    port === '4206' ||
    port === '4208' ||
    port === '4210'

  // console.log({ host, port, result })

  return result
}
